"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    isOtherOption: false,
    onBlur: function () {
        /* do nothing */
    },
    onClick: function () {
        /* do nothing */
    },
    onChange: function () {
        /* do nothing */
    },
    onKeyDown: function () {
        /* do nothing */
    },
    selected: false,
    otherInputValue: '',
    smallIcon: false,
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map